import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { DocumentSerie } from 'shell/models/document-serie';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

interface SelectSerieProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  id: string;
  label?: string;
  error?: boolean;
  isSmallSize?: boolean;
}

const SelectSerieComponent = ({
  disabled = false,
  onChange,
  value,
  id,
  label,
  error = false,
  isSmallSize = false,
}: SelectSerieProps): React.ReactElement => {
  const [series] = useHttpFetch<HttpResponseList<DocumentSerie>, Array<ItemVM>>(
    `${__CIVIL_STATUS_API_URL__}/serie-atto`,
    {
      onBootstrap: true,
      options: {
        method: 'GET',
      },
      transformer: (response) =>
        (response?.data?.payload?.list || []).map((item) => ({
          id: item.key?.codiceSerie || '',
          value: item.key?.codiceSerie || '',
        })),
    }
  );

  const seriesData = (series.data as Array<ItemVM>) || [];

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error}>{label}</InputLabel>
      <PmiSelect
        error={error}
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        disabled={disabled}
        label={label}
        size={isSmallSize ? 'small' : undefined}
      >
        <MenuItem value="">Nessuno</MenuItem>
        {seriesData.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.id}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

SelectSerieComponent.displayName = 'List serie component';

const SelectSerie = memo(SelectSerieComponent);

export default SelectSerie as typeof SelectSerieComponent;
